export default __webpack_public_path__ + "static/media/integration-failure.c45c9e00.svg";